import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import { FiltroUnidades } from "../filtros/FiltroUnidades";
import { unidadModel } from "../../models/unidad";
import { FormaRuta } from "./forms/FormaRuta";
import { FormaRegreso } from "./forms/FormaRegreso";
import { Spinner } from "../Spinner";
import { useUnidades } from "../../hooks/test/useUnidades";
import { useGeneral } from "../../hooks/test/useGeneral";
import { SocketContext } from "../../context/SocketContext";
import { CerrarEnRuta } from "../../helpers/controlSidebarEnRuta";
import { PaginatedItems } from "../customComponents/Pagination";
import { TituloUnidadesConteo } from "../customFunctionalComponents/components/TituloUnidadesConteo";
import { SinUnidades } from "../customFunctionalComponents/components/SinUnidades";
import { TarjetaUnidadesEnRuta } from "../customFunctionalComponents/components/TarjetaUnidadesEnRuta";
import { useJsApiLoader } from "@react-google-maps/api";
import { AuthContext } from "../../context/authContext/authContext";
import moment from "moment";

export const ListadoUnidades = ({ busqueda }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY
      ? process.env.GOOGLE_MAPS_API_KEY
      : "AIzaSyD6ekb2qbmZ3p9qfsi56PfuUKQt71fMMHg", //"AIzaSyAUjS4TZ1KxdAe113gf698s2o4WYGf-byc"
  });
  const { socket } = useContext(SocketContext);
  const [unidades, setUnidades] = useState([]);
  const [unidad, setUnidad] = useState(unidadModel);
  const [viaje, setViaje] = useState({});
  const { getUnidad, getUnidadesFiltro, getViajeUnidad } = useUnidades();
  const { openSidebar } = useGeneral();
  const [loading, setLoading] = useState(false);
  const [numeroPagina, setNumeroPagina] = useState(1);
  const [arrayCedis, setArrayCedis] = useState([]);
  const [palabra, setPalabra] = useState("");
  const [paginado, setPaginado] = useState({ totalPaginas: 0, pagina: 1 });
  const lastCallRef = useRef();
  const { user, negocioSeleccionado } = useContext(AuthContext);

  const cleanUp = () => {
    setUnidades([]);
    setPaginado({ totalPaginas: 0, pagina: 1 });
    setLoading(false);
    console.log("limpiando");
  };

  const loadUnidades = useCallback(
    async (page = numeroPagina) => {
      setLoading(true);
      const callId = Symbol();
      lastCallRef.current = callId;

      const resp = await getUnidadesFiltro({
        busqueda,
        numeroPagina: page,
        search: palabra,
        arrayCedis: { arrayCedis }, // SIEMPRE consistente
      });

      if (lastCallRef.current !== callId) return;

      if (!resp.ok) {
        cleanUp();
        return;
      }

      setUnidades(resp.data?.unidades ?? []);
      setPaginado(resp.data?.paginacion ?? { totalPaginas: 0, pagina: 1 });
      setLoading(false);
    },
    [palabra, arrayCedis, numeroPagina] // NO incluir numeroPagina
  );

  // BUSCAR: siempre reinicia a página 1
  useEffect(() => {
    loadUnidades(1);
  }, [palabra, arrayCedis]);
  // console.log(numeroPagina);

  // SOLO un listener del socket
  useEffect(() => {
    if (!socket) return;

    const handler = (data) => {
      let existeNegocio =
        negocioSeleccionado &&
        negocioSeleccionado.some((item) => item.negocio_id === data.idNegocio);

      if (data.idNegocio === user.negocio_id || existeNegocio) {
        loadUnidades();
      }
    };

    socket.on("new_event_robo_", async (data) => {
      console.log("new event robo actualizando Unidades en ruta");
      if (data.idNegocio === user.negocio_id || data.idNegocio === parseInt(negocioSeleccionado)) loadUnidades(numeroPagina);
    });

    socket.on("unidades_en_ruta_", handler);

    return () => { 
      socket.off("unidades_en_ruta_", handler);
      socket.off("new_event_robo_", handler);
    };

  }, [socket, negocioSeleccionado, user.negocio_id]);

  const selectUnidad = async (id_unidad) => {
    CerrarEnRuta();
    setLoading(true);
    let resp = await getUnidad(id_unidad);
    if (resp.ok) {
      setUnidad({ ...resp.unidad });
      openSidebar(resp.unidad.status_id);
      resp = await getViajeUnidad(id_unidad);
      if (resp.ok) setViaje(resp);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const calculoHora = (horaUltimaActualizacion) => {
    // console.log("horaUltimaActualizacion: " +horaUltimaActualizacion);
    let fecha1 = moment().format("YYYY-MM-DD HH:mm:ss");
    fecha1 = new Date(fecha1).getTime();

    // console.log("fecha1: " + fecha1);
    let fecha2 = moment(horaUltimaActualizacion)
      .local()
      .format("YYYY-MM-DD HH:mm:ss");
    fecha2 = new Date(fecha2).getTime();
    // console.log("fecha2: " + fecha2);
    let milisegundos = fecha1 - fecha2;
    let dias = Math.trunc(milisegundos / (1000 * 60 * 60 * 24));
    // console.log("Diff in days: " + dias);
    let minutes = Math.trunc(milisegundos / (1000 * 60));
    // console.log("minutes: "+minutes);
    // minutes = minutes * -1;

    if (minutes <= 40) return "green";
    if (minutes >= 41 && minutes <= 60) return "yellow";
    if (minutes >= 61 && minutes <= 90) return "orange";
    if (minutes > 90) return "red";
    return "black";
  };

  const handlePageChange = (page) => {
    setNumeroPagina(page);
    loadUnidades(page);
  };

  const handleChange = (campo, valor) => {
    if (campo === "palabra") {
      return setPalabra(valor);
    }

    if (campo === "arrayCedis") {
      // valor = array completo de IDs
      return setArrayCedis(valor);
    }
  };
  return (
    <>
      {loading && <Spinner />}
      <div className="row">
        <div id="enRuta" className="">
          <FiltroUnidades onChange={handleChange} />
          <TituloUnidadesConteo
            longitud={paginado.totalRegistros}
          ></TituloUnidadesConteo>
          <div className="col-12 col-sm-10 col-md-12 col-lg-12 col-xl-10 mx-auto">
            <SinUnidades longitud={unidades.length}></SinUnidades>
            <PaginatedItems
              paginacion={paginado || { totalPaginas: 0, pagina: 1 }}
              onPageChange={handlePageChange}
              items={(unidades || []).map((unidad) => {
                const {
                  unidad_id,
                  unidad_numero,
                  cedi,
                  status,
                  spot,
                  nombre_transportadora,
                  viajes = [], // <---- valor por default seguro
                  negocio_id,
                  comands_logs = [],
                  tipo_unidad_id,
                } = unidad;

                let aux =
                  viajes?.length > 0 &&
                  viajes[0]?.bitacora_monitorista?.length > 0
                    ? calculoHora(
                        viajes[0].bitacora_monitorista[0].bitacora_fecha_hora
                      )
                    : "black";

                return (
                  <TarjetaUnidadesEnRuta
                    status={status}
                    selectUnidad={selectUnidad}
                    unidad_id={unidad_id}
                    unidad_numero={unidad_numero}
                    cedi={cedi}
                    spot={spot}
                    nombre_transportadora={nombre_transportadora}
                    viajes={viajes}
                    colorUnit={aux}
                    negocioId={negocio_id}
                    comandos={comands_logs}
                    tipo_unidad_id={tipo_unidad_id}
                  ></TarjetaUnidadesEnRuta>
                );
              })}
            />
          </div>
        </div>
        {/* <br></br> */}

        <div className="col-3" id="enRuta" style={{ padding: "10px" }}>
          {isLoaded !== false ? (
            <>
              <FormaRuta
                viaje={viaje}
                unidad={unidad}
                getUnidades={loadUnidades}
                isLoaded={isLoaded}
              ></FormaRuta>
            </>
          ) : (
            ""
          )}
        </div>
        <div className="row" id="regresos">
          <FormaRegreso
            viaje={viaje}
            unidad={unidad}
            getUnidades={loadUnidades}
          ></FormaRegreso>
        </div>
      </div>
    </>
  );
};
